module.exports = __webpack_public_path__ + "img/close-icon.fc6abaef.svg";